module.exports = __webpack_public_path__ + "static/media/990978.66f66cbf.png";